(ns web3.constants
  (:require [web3.env :as env]))

(def encompass-service-is-enabled? false)

(def z-index {:snackbar 20
              :autocomplete 19
              :intercom-badge 18
              :alert-modal 17
              :router/drawer 15
              :router/form-modal 16
              :router/content-modal 14
              :add-button 13
              :root/main 2})

(def colors {
             ;; Primary
             :centriq "#28BBB5"
             :homeserve "#E7342C"
             :white "#ffffff"
             :off-white "#f6f6f6"
             :light-gray "#e2e2e2"
             :mid-gray "#dadada"
             :gray "#cccccc"
             :dark-gray "#8F9296"
             :black "#20262D"
             :black-hover "#44484D"
             :welcome/text "#E7342C"

             ;; Secondary
             :blue "#2B97DF"
             :yellow "#FEB63F"
             :orange "#EB712F"
             :red "#D7311F"

             ;; Tertiary
             :positive "#A6E867"
             :neutral "#FEB63F"
             :negative "#51B8FD"

             ;; Added
             :real-black "#000000"

             :alert-blue "#9FE6EC"
             :alert-yellow "#FFE14C"

             :light-green "#A0E6EC"})

#?(:cljs (def graphql-introspection-query-data
           "Static schema data for apollo to normalize query data.

           Use script in dev.fragment-matcher to update this whenever api changes."
           #js{:__schema #js{:types #js[#js{:kind "INTERFACE",
                                            :name "Entity",
                                            :possibleTypes #js[#js{:name "User"}
                                                               #js{:name "Content"}
                                                               #js{:name "UserReferral"}
                                                               #js{:name "PropertyTransferView"}
                                                               #js{:name "PropertyRight"}
                                                               #js{:name "Property"}
                                                               #js{:name "AssetGroup"}
                                                               #js{:name "Asset"}
                                                               #js{:name "Model"}
                                                               #js{:name "Manufacturer"}
                                                               #js{:name "Product"}
                                                               #js{:name "Tag"}
                                                               #js{:name "Recall"}
                                                               #js{:name "ServiceProvider"}
                                                               #js{:name "Sponsor"}
                                                               #js{:name "PropertyTransferRequest"}]}
                                        #js{:kind "INTERFACE",
                                            :name "Contented",
                                            :possibleTypes #js[#js{:name "Property"}
                                                               #js{:name "AssetGroup"}
                                                               #js{:name "Asset"}
                                                               #js{:name "Model"}
                                                               #js{:name "Tag"}]}
                                        #js{:kind "INTERFACE",
                                            :name "Profile",
                                            :possibleTypes #js[#js{:name "User"}
                                                               #js{:name "ServiceProvider"}
                                                               #js{:name "Sponsor"}]}]}}))



;; country and region data from https://www.freeformatter.com

(def countries
  "Countries of the world, in order that they should be presented in UI.

  [<ISO-3166-1 alpha-3 code>, <label>]"

  [["USA" "United States"]
   ["CAN" "Canada"]

   ["AFG" "Afghanistan"]
   ["ALA" "Åland Islands"]
   ["ALB" "Albania"]
   ["DZA" "Algeria"]
   ["ASM" "American Samoa"]
   ["AND" "Andorra"]
   ["AGO" "Angola"]
   ["AIA" "Anguilla"]
   ["ATA" "Antarctica"]
   ["ATG" "Antigua and Barbuda"]
   ["ARG" "Argentina"]
   ["ARM" "Armenia"]
   ["ABW" "Aruba"]
   ["AUS" "Australia"]
   ["AUT" "Austria"]
   ["AZE" "Azerbaijan"]
   ["BHS" "Bahamas"]
   ["BHR" "Bahrain"]
   ["BGD" "Bangladesh"]
   ["BRB" "Barbados"]
   ["BLR" "Belarus"]
   ["BEL" "Belgium"]
   ["BLZ" "Belize"]
   ["BEN" "Benin"]
   ["BMU" "Bermuda"]
   ["BTN" "Bhutan"]
   ["BOL" "Bolivia, Plurinational State of"]
   ["BES" "Bonaire, Sint Eustatius and Saba"]
   ["BIH" "Bosnia and Herzegovina"]
   ["BWA" "Botswana"]
   ["BVT" "Bouvet Island"]
   ["BRA" "Brazil"]
   ["IOT" "British Indian Ocean Territory"]
   ["BRN" "Brunei Darussalam"]
   ["BGR" "Bulgaria"]
   ["BFA" "Burkina Faso"]
   ["BDI" "Burundi"]
   ["KHM" "Cambodia"]
   ["CMR" "Cameroon"]
   ["CPV" "Cape Verde"]
   ["CYM" "Cayman Islands"]
   ["CAF" "Central African Republic"]
   ["TCD" "Chad"]
   ["CHL" "Chile"]
   ["CHN" "China"]
   ["CXR" "Christmas Island"]
   ["CCK" "Cocos (Keeling) Islands"]
   ["COL" "Colombia"]
   ["COM" "Comoros"]
   ["COG" "Congo"]
   ["COD" "Congo, the Democratic Republic of the"]
   ["COK" "Cook Islands"]
   ["CRI" "Costa Rica"]
   ["CIV" "Côte d'Ivoire"]
   ["HRV" "Croatia"]
   ["CUB" "Cuba"]
   ["CUW" "Curaçao"]
   ["CYP" "Cyprus"]
   ["CZE" "Czech Republic"]
   ["DNK" "Denmark"]
   ["DJI" "Djibouti"]
   ["DMA" "Dominica"]
   ["DOM" "Dominican Republic"]
   ["ECU" "Ecuador"]
   ["EGY" "Egypt"]
   ["SLV" "El Salvador"]
   ["GNQ" "Equatorial Guinea"]
   ["ERI" "Eritrea"]
   ["EST" "Estonia"]
   ["ETH" "Ethiopia"]
   ["FLK" "Falkland Islands (Malvinas)"]
   ["FRO" "Faroe Islands"]
   ["FJI" "Fiji"]
   ["FIN" "Finland"]
   ["FRA" "France"]
   ["GUF" "French Guiana"]
   ["PYF" "French Polynesia"]
   ["ATF" "French Southern Territories"]
   ["GAB" "Gabon"]
   ["GMB" "Gambia"]
   ["GEO" "Georgia"]
   ["DEU" "Germany"]
   ["GHA" "Ghana"]
   ["GIB" "Gibraltar"]
   ["GRC" "Greece"]
   ["GRL" "Greenland"]
   ["GRD" "Grenada"]
   ["GLP" "Guadeloupe"]
   ["GUM" "Guam"]
   ["GTM" "Guatemala"]
   ["GGY" "Guernsey"]
   ["GIN" "Guinea"]
   ["GNB" "Guinea-Bissau"]
   ["GUY" "Guyana"]
   ["HTI" "Haiti"]
   ["HMD" "Heard Island and McDonald Islands"]
   ["VAT" "Holy See (Vatican City State)"]
   ["HND" "Honduras"]
   ["HKG" "Hong Kong"]
   ["HUN" "Hungary"]
   ["ISL" "Iceland"]
   ["IND" "India"]
   ["IDN" "Indonesia"]
   ["IRN" "Iran, Islamic Republic of"]
   ["IRQ" "Iraq"]
   ["IRL" "Ireland"]
   ["IMN" "Isle of Man"]
   ["ISR" "Israel"]
   ["ITA" "Italy"]
   ["JAM" "Jamaica"]
   ["JPN" "Japan"]
   ["JEY" "Jersey"]
   ["JOR" "Jordan"]
   ["KAZ" "Kazakhstan"]
   ["KEN" "Kenya"]
   ["KIR" "Kiribati"]
   ["PRK" "Korea, Democratic People's Republic of"]
   ["KOR" "Korea, Republic of"]
   ["KWT" "Kuwait"]
   ["KGZ" "Kyrgyzstan"]
   ["LAO" "Lao People's Democratic Republic"]
   ["LVA" "Latvia"]
   ["LBN" "Lebanon"]
   ["LSO" "Lesotho"]
   ["LBR" "Liberia"]
   ["LBY" "Libya"]
   ["LIE" "Liechtenstein"]
   ["LTU" "Lithuania"]
   ["LUX" "Luxembourg"]
   ["MAC" "Macao"]
   ["MKD" "Macedonia, the former Yugoslav Republic of"]
   ["MDG" "Madagascar"]
   ["MWI" "Malawi"]
   ["MYS" "Malaysia"]
   ["MDV" "Maldives"]
   ["MLI" "Mali"]
   ["MLT" "Malta"]
   ["MHL" "Marshall Islands"]
   ["MTQ" "Martinique"]
   ["MRT" "Mauritania"]
   ["MUS" "Mauritius"]
   ["MYT" "Mayotte"]
   ["MEX" "Mexico"]
   ["FSM" "Micronesia, Federated States of"]
   ["MDA" "Moldova, Republic of"]
   ["MCO" "Monaco"]
   ["MNG" "Mongolia"]
   ["MNE" "Montenegro"]
   ["MSR" "Montserrat"]
   ["MAR" "Morocco"]
   ["MOZ" "Mozambique"]
   ["MMR" "Myanmar"]
   ["NAM" "Namibia"]
   ["NRU" "Nauru"]
   ["NPL" "Nepal"]
   ["NLD" "Netherlands"]
   ["NCL" "New Caledonia"]
   ["NZL" "New Zealand"]
   ["NIC" "Nicaragua"]
   ["NER" "Niger"]
   ["NGA" "Nigeria"]
   ["NIU" "Niue"]
   ["NFK" "Norfolk Island"]
   ["MNP" "Northern Mariana Islands"]
   ["NOR" "Norway"]
   ["OMN" "Oman"]
   ["PAK" "Pakistan"]
   ["PLW" "Palau"]
   ["PSE" "Palestinian Territory, Occupied"]
   ["PAN" "Panama"]
   ["PNG" "Papua New Guinea"]
   ["PRY" "Paraguay"]
   ["PER" "Peru"]
   ["PHL" "Philippines"]
   ["PCN" "Pitcairn"]
   ["POL" "Poland"]
   ["PRT" "Portugal"]
   ["PRI" "Puerto Rico"]
   ["QAT" "Qatar"]
   ["REU" "Réunion"]
   ["ROU" "Romania"]
   ["RUS" "Russian Federation"]
   ["RWA" "Rwanda"]
   ["BLM" "Saint Barthélemy"]
   ["SHN" "Saint Helena, Ascension and Tristan da Cunha"]
   ["KNA" "Saint Kitts and Nevis"]
   ["LCA" "Saint Lucia"]
   ["MAF" "Saint Martin (French part)"]
   ["SPM" "Saint Pierre and Miquelon"]
   ["VCT" "Saint Vincent and the Grenadines"]
   ["WSM" "Samoa"]
   ["SMR" "San Marino"]
   ["STP" "Sao Tome and Principe"]
   ["SAU" "Saudi Arabia"]
   ["SEN" "Senegal"]
   ["SRB" "Serbia"]
   ["SYC" "Seychelles"]
   ["SLE" "Sierra Leone"]
   ["SGP" "Singapore"]
   ["SXM" "Sint Maarten (Dutch part)"]
   ["SVK" "Slovakia"]
   ["SVN" "Slovenia"]
   ["SLB" "Solomon Islands"]
   ["SOM" "Somalia"]
   ["ZAF" "South Africa"]
   ["SGS" "South Georgia and the South Sandwich Islands"]
   ["SSD" "South Sudan"]
   ["ESP" "Spain"]
   ["LKA" "Sri Lanka"]
   ["SDN" "Sudan"]
   ["SUR" "Suriname"]
   ["SJM" "Svalbard and Jan Mayen"]
   ["SWZ" "Swaziland"]
   ["SWE" "Sweden"]
   ["CHE" "Switzerland"]
   ["SYR" "Syrian Arab Republic"]
   ["TWN" "Taiwan, Province of China"]
   ["TJK" "Tajikistan"]
   ["TZA" "Tanzania, United Republic of"]
   ["THA" "Thailand"]
   ["TLS" "Timor-Leste"]
   ["TGO" "Togo"]
   ["TKL" "Tokelau"]
   ["TON" "Tonga"]
   ["TTO" "Trinidad and Tobago"]
   ["TUN" "Tunisia"]
   ["TUR" "Turkey"]
   ["TKM" "Turkmenistan"]
   ["TCA" "Turks and Caicos Islands"]
   ["TUV" "Tuvalu"]
   ["UGA" "Uganda"]
   ["UKR" "Ukraine"]
   ["ARE" "United Arab Emirates"]
   ["GBR" "United Kingdom"]
   ["UMI" "United States Minor Outlying Islands"]
   ["URY" "Uruguay"]
   ["UZB" "Uzbekistan"]
   ["VUT" "Vanuatu"]
   ["VEN" "Venezuela, Bolivarian Republic of"]
   ["VNM" "Viet Nam"]
   ["VGB" "Virgin Islands, British"]
   ["VIR" "Virgin Islands, U.S."]
   ["WLF" "Wallis and Futuna"]
   ["ESH" "Western Sahara"]
   ["YEM" "Yemen"]
   ["ZMB" "Zambia"]
   ["ZWE" "Zimbabwe"]])

(def states
  [["AL" "Alabama"]
   ["AK" "Alaska"]
   ["AZ" "Arizona"]
   ["AR" "Arkansas"]
   ["CA" "California"]
   ["CO" "Colorado"]
   ["CT" "Connecticut"]
   ["DE" "Delaware"]
   ["DC" "District Of Columbia"]
   ["FL" "Florida"]
   ["GA" "Georgia"]
   ["HI" "Hawaii"]
   ["ID" "Idaho"]
   ["IL" "Illinois"]
   ["IN" "Indiana"]
   ["IA" "Iowa"]
   ["KS" "Kansas"]
   ["KY" "Kentucky"]
   ["LA" "Louisiana"]
   ["ME" "Maine"]
   ["MD" "Maryland"]
   ["MA" "Massachusetts"]
   ["MI" "Michigan"]
   ["MN" "Minnesota"]
   ["MS" "Mississippi"]
   ["MO" "Missouri"]
   ["MT" "Montana"]
   ["NE" "Nebraska"]
   ["NV" "Nevada"]
   ["NH" "New Hampshire"]
   ["NJ" "New Jersey"]
   ["NM" "New Mexico"]
   ["NY" "New York"]
   ["NC" "North Carolina"]
   ["ND" "North Dakota"]
   ["OH" "Ohio"]
   ["OK" "Oklahoma"]
   ["OR" "Oregon"]
   ["PA" "Pennsylvania"]
   ["RI" "Rhode Island"]
   ["SC" "South Carolina"]
   ["SD" "South Dakota"]
   ["TN" "Tennessee"]
   ["TX" "Texas"]
   ["UT" "Utah"]
   ["VT" "Vermont"]
   ["VA" "Virginia"]
   ["WA" "Washington"]
   ["WV" "West Virginia"]
   ["WI" "Wisconsin"]
   ["WY" "Wyoming"]

   ["AS" "American Samoa"]
   ["GU" "Guam"]
   ["MP" "Northern Mariana Islands"]
   ["PR" "Puerto Rico"]
   ["UM" "United States Minor Outlying Islands"]
   ["VI" "Virgin Islands"]

   ["AA" "Armed Forces Americas"]
   ["AP" "Armed Forces Pacific"]
   ["AE" "Armed Forces Others"]])

(def provinces
  [["AB" "Alberta"]
   ["BC" "British Columbia"]
   ["MB" "Manitoba"]
   ["NB" "New Brunswick"]
   ["NL" "Newfoundland and Labrador"]
   ["NS" "Nova Scotia"]
   ["ON" "Ontario"]
   ["PE" "Prince Edward Island"]
   ["QC" "Quebec"]
   ["SK" "Saskatchewan"]
   ["NT" "Northwest Territories"]
   ["NU" "Nunavut"]
   ["YT" "Yukon"]])

(def find-a-pro-link "https://www.homeadvisor.com/")

